// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34cYQ","newExpiryDate":"styles_newExpiryDate__3mV_z","footer":"styles_footer__14PLK"};